export const categories = [
  "Car",
  "Bike",
  "Tractor",
  "JCB",
  "Goods_Vehicle",
  "Agriculture_Vehicle",
];

export const brandsByCategory = {
  Car: [
    "Ambassador",
    "Bajaj",
    "BMW",
    "Chevrolet",
    "Datsun",
    "Fiat",
    "Ford",
    "Honda",
    "Hyundai",
    "Land_Rover",
    "Mahindra",
    "Maruthi",
    "Mercedes",
    "Mitsubishi",
    "Nissan",
    "Opel",
    "Renault",
    "Skoda",
    "Tata",
    "Toyota",
    "Volkswagen",
    "Other_Brand",
  ],
  Bike: [
    "Bajaj",
    "Hero",
    "Honda",
    "Mahindra",
    "Royal_Enfield",
    "Suzuki",
    "TVS",
    "Yamaha",
    "Other_Brand",
  ],
  Tractor: [
    "ACE",
    "Captain",
    "Digitrac",
    "Eicher",
    "Escorts",
    "Farmtrac",
    "Force",
    "Hindustan",
    "Indo Farm",
    "John_Deere",
    "Kartar",
    "Kubota",
    "Mahindra",
    "Massey_Ferguson",
    "New_Holland",
    "Powertrac",
    "Preet",
    "Same Deutz Fahr",
    "Solis",
    "Sonalika",
    "Swaraj",
    "Trakstar",
    "VST",
    "Other_Brand",
  ],
  JCB: ["Other_Brand"],
  Goods_Vehicle: ["Other_Brand"],
  Agriculture_Vehicle: ["Other_Brand"],
};

export const modelsByBrand = {
  
  Ambassador: ["Ambassador", "Contessa", "Other_Model"],
  Bajaj: ["Auto", "Qute", "Other_Model"],
  BMW: ["525", "M_5", "Other_Model"],
  Chevrolet: [
    "Aveo",
    "Beat",
    "Cruze",
    "Optra",
    "Sail",
    "Spark",
    "Tavera",
    "UVA",
    "Other_Model",
  ],
  Datsun: ["Datsun_Go", "Redi_Go", "Other_Model"],
  Fiat: [
    "Evo",
    "Linea",
    "Padmini",
    "Palio",
    "Premier_118",
    "Punto",
    "Siena",
    "Uno",
    "Other_Model",
  ],
  Ford: [
    "Aspire",
    "EcoSport",
    "Endeavour",
    "Escort",
    "Figo",
    "Fiesta",
    "Fusion",
    "Ikon",
    "Mondeo",
    "Other_Model",
  ],
  Honda: [
    "Accord",
    "Amaze",
    "Brio",
    "BR_V",
    "City",
    "Civic",
    "CR_V",
    "Jazz",
    "WR_V",
    "Other_Model",
  ],
  Hyundai: [
    "Accent",
    "Creta",
    "Elantra",
    "i10",
    "i20",
    "Santa_FE",
    "Santro",
    "Sonata",
    "Terracan",
    "Tucson",
    "Venue",
    "Verna",
    "Other_Model",
  ],
  Land_Rover: ["Defender", "Discovery", "Range_Rover", "Other_Model"],
  Mahindra: ["Bolero", "Scorpio", "Xylo", "Other_Model"],
  Maruthi: [
    "800",
    "1000",
    "A_Star",
    "Alto",
    "Baleno",
    "Breeza",
    "Ciaz",
    "Ertiga",
    "Esteem",
    "Gypsy",
    "Omni",
    "Ritz",
    "S_Presso",
    "Swift",
    "Swift_Dzire",
    "Versa",
    "Vitara",
    "Wagon_R",
    "Zen",
    "Zen_Estilo",
    "Other_Model",
  ],
  Mercedes: ["300_D", "Benz_C", "Benz_E", "Benz_S", "C_200", "Other_Model"],
  Mitsubishi: [
    "Cedia",
    "Challenger",
    "Lancer",
    "Montero",
    "Pajero",
    "Other_Model",
  ],
  Nissan: ["Kicks", "Magnite", "Micra", "Sunny", "Other_Model"],
  Opel: ["Astra", "Corsa", "Vectra", "Other_Model"],
  Renault: ["Duster", "Other_Model"],
  Skoda: ["Fabia", "Laura", "Octavia", "Rapid", "Superb", "Other_Model"],
  Tata: [
    "Aria",
    "Bolt",
    "Estate",
    "Indica",
    "Indigo",
    "Indigo_Marina",
    "Manza",
    "Nano",
    "Safari",
    "Sierra",
    "Sumo",
    "Sumo_Grande",
    "Vista",
    "Zest",
    "Other_Model",
  ],
  Toyota: ["Corolla", "Etios", "Fortuner", "Innova", "Other_Model"],
  Volkswagen: ["Jetta", "Polo", "Tiguan", "Vento", "Other_Model"],

  
  
  
  Honda_Bike: [
    "Activa",
    "Aviator",
    "CB_(Series)",
    "CB_200",
    "CD_100",
    "CRB_(Series)",
    "Dio",
    "Eterno",
    "Grazia",
    "HNESS",
    "Hornet",
    "Kinetic",
    "Livo",
    "Shine",
    "SP",
    "Unicorn",
    "X_Blade",
    "Other_Model",
  ],
  Bajaj_Bike: [
    "Avenger",
    "Chetak",
    "CT_100",
    "CUB",
    "Discover",
    "Dominar",
    "Platina",
    "Priya",
    "Pulsar",
    "Other_Model",
  ],
  Mahindra_Bike: ["Centuro", "Gusto", "Mojo", "Rodeo", "Other_Model"],
  Hero: [
    "CBZ",
    "Destini",
    "Glamour",
    "Hf_Deluxe",
    "Maestro",
    "Mastro",
    "Passion",
    "Pleasure",
    "Splender",
    "Super_Splender",
    "X_Pulse",
    "Xtreme",
    "Other_Model",
  ],
  Royal_Enfield: [
    "Bullet_350cc",
    "Bullet_500cc",
    "RoyalEnfield",
    "Thunderbird",
    "Other_Model",
  ],
  Suzuki: [
    "Access_125",
    "Avenis",
    "Burgman",
    "Fiero",
    "Gixxer",
    "Heat",
    "Samuri",
    "Shogun",
    "Other_Model",
  ],
  TVS: [
    "Apache",
    "Fiero",
    "i_Qube_EV",
    "Jupitor",
    "N_Torq",
    "Radeon",
    "Rider",
    "Scooty_Pep",
    "Scooty_Zest",
    "Sport",
    "Star_City",
    "Super_XL",
    "Victor",
    "XL_100",
    "Other_Model",
  ],
  Yamaha: [
    "Aerox",
    "Fascino",
    "Fazer",
    "FZ",
    "Libero",
    "R_15",
    "Ray_ZR",
    "RX_100",
    "Other_Model",
  ],

  
  Mahindra_Tractor: ["Mahindra_575_DI", "Mahindra_Arjun_555_DI", "Other_Model"],
};



const brandModelKey = {
  Bike: { Honda: "Honda_Bike", Bajaj: "Bajaj_Bike", Mahindra: "Mahindra_Bike" },
  Tractor: { Mahindra: "Mahindra_Tractor" },
};


export function getModels(category, brand) {
  if (!brand || brand === "Other_Brand") return [];
  const key = brandModelKey[category]?.[brand] || brand;
  return modelsByBrand[key] || [];
}

export const fuelTypes = [
  "Petrol",
  "Diesel",
  "Petrol_CNG",
  "EV",
  "Hybrid",
  "CNG",
];


export function toLabel(val) {
  if (!val) return "";
  return val.replace(/_/g, " ");
}
